<footer class="footer">
  <div class="footer__copyright">
    <span>{{ 'footer.version' | translate: { version: version } }}</span>
    <span class="swd-link-separator">|</span>
    <span>&copy; {{ currentYear }} {{ 'footer.text' | translate }}</span>
  </div>
  <div class="footer__language-picker">
    <app-language-picker></app-language-picker>
  </div>
</footer>
